/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Number_Of_Segments_LabelInputs */



/**
* | output |
* | --- |
* | "Number of Segments" |
*
* @param {Segment_Event_Group_Number_Of_Segments_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_number_of_segments_label = /** @type {((inputs?: Segment_Event_Group_Number_Of_Segments_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Number_Of_Segments_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre de segments")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzahl der Segmente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di segmenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество сегментов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de segmentos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("段数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメント数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंडों की संख्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número de segmentos")
	return /** @type {LocalizedString} */ ("Number of Segments")
});